import { OffersList, IOffersListProps } from './OffersList';
import { OffersListLazyWrapper } from './OffersListLazyWrapper';

export const LazyOffersList = (props: IOffersListProps) => {
  return (
    <OffersListLazyWrapper>
      <OffersList {...props} />
    </OffersListLazyWrapper>
  );
};
